import moment from 'moment'

const cart = {
  cartId: '',
  display: false,
  loading: false,
  cartCheckoutButtonLoading: false,
  hasItemsMovedToCart: false,
  hasItemsMovedToBackOrder: false,
  list: {},
  report: {},
  pointsEarned: '0',
  statusCredits: '0',
  selectedProductID: [],
  isClearCartLoading: false,
}

export const generateCartItem = (payload) => {
  const defaults = {
    SupplierExternalID: null,
    BundleType: null,
    BuyableID: null,
    DiscountTotal: null,
    DisplayImage: null,
    ID: null,
    ItemsInCase: null,
    PointsEarned: null,
    StatusCredits: null,
    Title: null,
    TotalPrice: null,
    TotalUnitItems: null,
    UnitPrice: null,
    WebCategory: null,
    LoyaltyPoints: null,
  }

  const data = {
    ...defaults,
    ...payload,
  }

  if (payload?.Buyable?.SupplierExternalID) {
    data.SupplierExternalID = payload.Buyable.SupplierExternalID
  }
  if (payload?.Buyable?.ID) {
    data.BuyableID = payload.Buyable.ID
  }
  if (payload?.Buyable?.ItemsInCase) {
    data.ItemsInCase = payload.Buyable.ItemsInCase
  }
  if (payload?.Buyable?.PointsEarned) {
    data.PointsEarned = payload.Buyable.PointsEarned
  }
  if (payload?.Buyable?.StatusCredits) {
    data.StatusCredits = payload.Buyable.StatusCredits
  }
  if (payload?.Buyable?.WebCategory) {
    data.WebCategory = payload.Buyable.WebCategory
  }
  if (payload?.Buyable?.LoyaltyPoints) {
    data.LoyaltyPoints = payload.Buyable.LoyaltyPoints
  }

  // Convert to numbers
  const toNumberKeys = [
    'CalculatedSubTotalPrice',
    'PointsEarned',
    'StatusCredits',
    'TotalPrice',
    'TotalUnitItems',
    'UnitPrice',
    'LoyaltyPoints',
  ]
  toNumberKeys.forEach((key) => {
    data[key] = Number(data[key])
  })

  // Delete unneeded stuff
  delete data.Buyable

  return data
}

function updateCartList(list, products) {
  return Object.entries(products).reduce(
    (list, [key, product]) => {
      const { id, caseTotal, unitTotal } = product
      let { created } = product

      // empty product (uncomment below if this is required)
      if (!caseTotal && !unitTotal) {
        return removeItem(list, id)
      }

      // timestamp for sorting later
      created = created || moment('now').format('YYYY-MM-DD HH:mm:ss')

      return {
        ...list,
        [id]: {
          ...product,
          created: created,
        },
      }
    },
    {
      ...list,
    }
  )
}
function removeItem(list, id) {
  const { [id]: removedItem, ...rest } = list
  // console.log('Removed item', id, removedItem);
  return rest
}

const CartReducer = function (state = cart, action) {
  switch (action.type) {
    case 'TOGGLE_CART': {
      return {
        ...state,
        display: action.value,
      }
    }
    case 'TOGGLE_CART_LOADING': {
      return {
        ...state,
        loading: action.value,
      }
    }
    case 'TOGGLE_CLEAR_CART_LOADING': {
      return {
        ...state,
        isClearCartLoading: action.value,
      }
    }
    case 'TOGGLE_CART_CHECKOUT_BUTTON_LOADING': {
      return {
        ...state,
        cartCheckoutButtonLoading: action.value,
      }
    }
    case 'SET_CART_SELECTED_PRODUCT': {
      return {
        ...state,
        selectedProductID: [...state.selectedProductID, action.value],
      }
    }
    case 'CLEAR_CART_SELECTED_PRODUCT': {
      return {
        ...state,
        selectedProductID: [],
      }
    }
    case 'SET_CART_LIST': {
      return {
        ...state,
        list: action.list,
      }
    }
    case 'SET_CART_ID': {
      return {
        ...state,
        cartId: action.value,
      }
    }
    case 'SET_CART_LOYALTY_POINTS': {
      return {
        ...state,
        pointsEarned: action.pointsEarned,
        statusCredits: action.statusCredits,
      }
    }
    case 'REMOVE_CART_ITEM': {
      const newList = removeItem(state.list, action.product.id)
      return {
        ...state,
        list: newList,
      }
    }
    case 'UPDATE_CART_ITEMS': {
      let newList = updateCartList(state.list, action.list)
      return {
        ...state,
        list: newList,
      }
    }
    case 'UPDATE_ITEMS_MOVED_TO_CART': {
      return {
        ...state,
        hasItemsMovedToCart: action.value,
      }
    }
    case 'UPDATE_ITEMS_MOVED_TO_BACK_ORDER': {
      return {
        ...state,
        hasItemsMovedToCart: action.value,
      }
    }
    case 'UPDATE_CART_REPORT': {
      return {
        ...state,
        report: action.data,
      }
    }
    default: {
      return state
    }
  }
}

export default CartReducer
